import React, { Component } from 'react';
import { Calendar, Icon } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';

class ECalendar extends Component {
    state = {
        date: moment().format(dateFormat),
    }

    componentDidMount() {
        this.triggerChange();
    }

    dateCellRender = value => {
        const { orangeList, blueList } = this.props;
        const hasOrange = orangeList.some(i => i === moment(value).format(dateFormat));
        if (hasOrange) {
            return <i className="calPoint" style={{ color: "#fa9314" }}>●</i>;
        }
        const hasBlue = blueList.some(i => i === moment(value).format(dateFormat));
        if (hasBlue) {
            return <i className="bluePoint">●</i>;
        }
    }

    handleDateSelect = (value) => {
        this.setState({
            date: moment(value).format(dateFormat),
        }, () => {
            this.triggerChange();
        });
    }

    changeMonth = (type) => {
        const { date } = this.state;
        const curdate = type == 'prev' ? moment(date).subtract(1, 'months').format(dateFormat) : moment(date).add(1, 'months').format(dateFormat);
        this.setState({
            date: curdate,
        }, () => {
            this.triggerChange();
        });
    }

    triggerChange = () => {
        const { date } = this.state;
        this.props.onSelect(date);
    }

    render() {
        const { date } = this.state;
        return (
            <div className="home-cal" style={{ width: '100%', borderRadius: 4 }}>
                <a onClick={() => this.changeMonth('prev')} className="leftChangeMonth">
                    <Icon type="left-circle-o" />
                </a>
                <a onClick={() => this.changeMonth('next')} className="RightChangeMonth" >
                    <Icon type="right-circle-o" />
                </a>
                <Calendar
                    mode="month"
                    fullscreen={false}
                    onPanelChange={this.handleDateSelect}
                    onSelect={this.handleDateSelect}
                    dateCellRender={this.dateCellRender}
                    value={moment(date)}
                />
            </div>
        );
    }
}

class AfficheNews extends Component {
    state = {
        hospitalId: '',
        data: [],
        isBlue: false,
        blueList: [],
        orangeList: [],
        today: moment().format(dateFormat),
        calendarDate: moment().format(dateFormat),
    }

    loadRemindPoint = () => {
        const { hospitalId, calendarDate } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryUpperCalendar,
            data: {
                hospitalId,
                date: moment(calendarDate).format(monthFormat),
            },
            dataType: 'json',
            doneResult: res => {
                const { blue, orange } = res;
                this.setState({
                    orangeList: orange,
                    blueList: blue,
                });
            }
        };
        $.sendRequest(options);
    }

    loadPlanOrActualList = () => {
        const { today, hospitalId, calendarDate } = this.state;
        const start_date = moment(calendarDate).unix();
        const end_date = moment(today).unix()
        const isBlue = start_date < end_date ? 1 : 0
        this.setState({ isBlue });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryUpperCalendarHospitalByDate,
            data: {
                isBlue,
                hospitalId,
                date: calendarDate,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({  data: res.data });
            }
        };
        $.sendRequest(options);
    }

    onSelect = (calendarDate) => {
        this.setState({
            calendarDate,
        }, () => {
            this.loadRemindPoint();
            this.loadPlanOrActualList();
        });
    }

    handleHighSearchInputChange = (id, options) => {
        const idx = options.findIndex(i => i.value == id);
        if (idx >= 0 || id === '') {
            this.setState({ hospitalId: id }, () => {
                this.loadRemindPoint();
            });
        }
    }

    render() {
        let { isBlue, blueList, orangeList, data } = this.state;
        return (
            <div className='flexItem outer'>
                <div className="modTitle">上会日历</div>
                <div className="flexBox">
                    <div className='side flexItem'>
                        <HighSearchInput
                            keyword='hospitalName'
                            style={{ width: '100%', marginTop: 8 }}
                            params={{ limit: 20 }}
                            placeholder={<div>搜索医院<span><Icon style={{ float: "right", marginTop: 5 }} type="search" /></span></div>}
                            url={API_URL.hospital.hospitalList}
                            config={{ id: 'hospitalId', name: 'hospitalName' }}
                            onChange={(id, options) => this.handleHighSearchInputChange(id, options)}
                        />
                        <div className='bgwhite Seance' style={{ marginTop: 8, marginBottom: 20 }}>
                            <ECalendar blueList={blueList} orangeList={orangeList} onSelect={this.onSelect} />
                        </div>
                    </div>
                    <div className='flexItem'>
                        <div style={{ marginTop: 8, paddingLeft: 4, lineHeight: '28px', fontWeight: 'bold', background: '#f1f1f1' }}>
                            {isBlue ? "实际上会医院名单" : "计划上会医院名单"}
                        </div>
                        <ul style={{ height: 480, overflowX: 'hidden', overflowY: 'auto' }}>
                            { data.map(d => <li key={d.hospitalId} style={{ padding: '6px 10px', borderBottom: '1px solid #ccc' }}>{d.hospitalName}</li>) }
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default AfficheNews;


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/SeanceCalendar.js